import React, { Component } from "react";
import {
  Card,
  Row,
  Col,
  Container,
  FormCheckbox,
  CardBody,
  Button
} from "shards-react";
import PageTitle from "../../components/common/PageTitle";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Language, API_URL ,  HEADER_ORIGIN,
  HEADER_ORIGIN_KEY,} from "../../config";
import { strings } from "../../localization";
import Loader from "react-loader-spinner";
import { Link } from "react-router-dom";

export default class ManageUserPermissions extends Component {
  state = {
    permissions: {},
    defaultPermissions: {},
    visible: true,
    method: "post",
    id: "",
    checkAll: false
  };
  constructor(props) {
    super(props);
    strings.setLanguage(Language);
  }

  onChangeSwitch(key, value) {
    this.setState({
      permissions: {
        ...this.state.permissions,
        [key]: !value
      }
    });

    // console.log(this.state.updatedPermissions);

    // this.setState({
    //   data: oldArray
    // });
  }

  componentDidMount() {
    let id = this.props.match.params.id;

    if (id) {
      fetch(`${API_URL}permissions?userid=${id}`, {
        method: "GET",
        credentials: "include"
      })
        .then(res => res.json())
        .then(data => {
          let responseData = data.data || {};
          let permissions = responseData.permissions || {};
          let id = data._id;

          if (id && Object.keys(permissions).length > 0) {
            this.setState({
              permissions,
              defaultPermissions: responseData.defaultPermissions || {},
              visible: false,
              method: "put",
              id: id
            });
          } else {
            this.setState({
              permissions: responseData.defaultPermissions || {},
              defaultPermissions: responseData.defaultPermissions || {},
              visible: false,
              method: id ? "put" : "post",
              id: id || ""
            });
          }
        })
        .catch(e => {
          this.setState({
            visible: false,
            permissions: this.state.defaultPermissions
          });
        });
    }

    // Object.fromEntries(
    //   Object.entries(this.state.permissions).map(([key, value]) => {
    //     console.log("Key : " + key);
    //     console.log("Value : " + value);
    //   })
    // );

    // this.mapObject(, );
  }

  checkAll() {
    //console.log(e.target);
    // console.log(e.checked);

    let array = { ...this.state.permissions };

    // alert("on");
    let value = !this.state.checkAll;

    Object.keys(array).forEach(function (key) {
      array[key] = value;
    });

    this.setState({
      permissions: array,
      checkAll: value
    });
  }

  // mapObject(obj, fn) {
  //   return Object.fromEntries(Object.entries(obj).map(fn));
  // }

  renderItems() {
    let data = this.state.permissions;
    let JSX = [];
    for (var key in data) {
      let key_ = key;
      //this.onChangeSwitch(key, data[key]);
      // console.log(data[key] + " : " + key);
      JSX.push(
        <Col lg="3" md="4" sm="6" key={key}>
          <hr />
          <FormCheckbox
            onChange={() => this.onChangeSwitch(key_, !!data[key_])}
            checked={!!data[key]}
            toggle
          >
            <span style={{ textTransform: "capitalize" }}>
              {key.replace(/_/g, " ")}
            </span>
          </FormCheckbox>
        </Col>
      );
    }
    return JSX;
  }

  handleClick() {
    let userInfo = localStorage.getItem("user_info");
    if (userInfo) {
      userInfo = JSON.parse(userInfo);
      // console.log(userInfo._id);
      this.setState({ button: true, loader: "fa fa-spinner fa-spin" });
      let currentUserID = this.props.match.params.id;
      // alert(this.state.method);
      let data = this.state.method === "put" ? "/" + this.state.id : "";
      let body = JSON.stringify({
        userID: currentUserID,
        permissions: this.state.permissions,
        "p-source": "cp"
      });
      let responseStatus = "";
      // data[HEADER_ORIGIN_KEY] = HEADER_ORIGIN;
      fetch(`${API_URL}permissions${data}`, {
        method: this.state.method,
        headers: {
          "Content-Type": "Application/json",
          // "p-source":"cp"
        },
        credentials: "include",
        body: body
      })
        .then(res => {
          responseStatus = res.status;
          return res.json();
        })
        .then(data => {
          // console.log(data);
          if (responseStatus === 400) {
            toast.error(data.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined
            });
          } else if (responseStatus === 200) {
            toast.success("Record saved successfully", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined
            });
            // this.setState({ button: false, loader: "" });
          } else {
            toast.error(data.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined
            });
          }
          this.setState({ loader: "", button: false });
        });
    }
  }

  render() {
    return (
      <div>
        <Container fluid className="main-content-container px-4">
          <Row noGutters className="page-header py-4">
            <Col>
              <PageTitle
                title="Permissions"
                subtitle="Overview"
                md="12"
                className="ml-sm-auto mr-sm-auto"
              />
            </Col>

            <Col style={{ display: "flex", justifyContent: "flex-end" }}>
              <Link to={"/customers"} className="float-left">
                <Button
                  size="sm"
                  id="go_back"
                  theme="light"
                  className="mb-2 mr-1"
                >
                  {strings.go_back}
                </Button>
              </Link>
            </Col>
          </Row>
          <Row>
            <Col lg="12" md="12" sm="12">
              <Card small className="mb-4">
                <CardBody className="p-3 pb-3">
                  {this.state.visible ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center"
                      }}
                    >
                      <Loader
                        type="Puff"
                        color="#00BFFF"
                        height={100}
                        width={100}
                        visible={this.state.visible}
                      />
                    </div>
                  ) : (
                    <>
                      <Row
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          marginRight: "10px"
                        }}
                      >
                        <FormCheckbox
                          toggle
                          onChange={() => this.checkAll()}
                          checked={this.state.checkAll && true}
                        >
                          Check All
                        </FormCheckbox>
                      </Row>
                      <Row>{this.renderItems()}</Row>
                      <div
                        style={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Button
                          theme="accent"
                          onClick={() => this.handleClick()}
                          disabled={this.state.button}
                        >
                          <i
                            className={this.state.loader}
                            style={{ fontSize: "15px" }}
                          ></i>{" "}
                          Save
                        </Button>
                      </div>
                    </>
                  )}
                  {/* {this.state.data.length > 0
                      ? this.state.data.map((value, k) => {
                          return (
                            <Col lg="3" md="4" sm="6">
                              <FormCheckbox
                                onChange={() =>
                                  this.onChangeSwitch(
                                    Object.keys(value),
                                    Object.values(value)[0],
                                    k
                                  )
                                }
                                toggle
                                checked={Object.values(value)[0] && true}
                              >
                                <span style={{ textTransform: "capitalize" }}>
                                  {Object.keys(value)
                                    .toString()
                                    .replace(/_/g, " ")}
                                </span>
                              </FormCheckbox>
                              <hr />
                            </Col>
                          );
                        })
                      : null} */}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
